import { __assign, __rest } from "tslib";
// DS5.2
import React from 'react';
import c from 'classnames';
import pick from 'lodash/pick';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks';
import Tabs from '../..';
import s from './UnderlinedTabs.scss';
import sUpdated from './UnderlinedTabs.updated_tabs.scss';
export var UnderlinedTabs = function (_a) {
    var _b = _a.size, size = _b === void 0 ? 'small' : _b, uniformTabWidth = _a.uniformTabWidth, items = _a.items, props = __rest(_a, ["size", "uniformTabWidth", "items"]);
    var isUpdatedTabs = useFlag('updated_tabs');
    return (React.createElement(Tabs, __assign({}, props, { items: items.map(function (item) {
            if (item.hasNotification) {
                var modifiedItem = __assign(__assign({}, item), { labelExtras: React.createElement("div", { className: sUpdated['notification-dot'] }) });
                return modifiedItem;
            }
            return item;
        }), viewClassNames: isUpdatedTabs
            ? {
                root: c(sUpdated['root'], sUpdated[size], uniformTabWidth && sUpdated['uniform-tabs']),
                tab: sUpdated['tab'],
                label: sUpdated['label'],
                prefix: sUpdated['prefix'],
                'active-tab': sUpdated['active-tab'],
            }
            : pick(s, 'root', 'tab', 'active-tab') })));
};
UnderlinedTabs.displayName = 'UnderlinedTabs';
export default UnderlinedTabs;
//# sourceMappingURL=UnderlinedTabs.js.map